module.exports = __webpack_public_path__ + "img/wx.d440cbf1.png";